// Current logged-in agent.
// Multi-tenant: user logs in with a business token; the server returns
// the SIP credentials + an agent session token used for subsequent /api/v1 calls.

import { create } from 'zustand'

const STORAGE_KEY = 'kaliai_user'

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}

const useUserStore = create((set) => ({
  // { extension, name, sip_password, agent_token, business, dids, default_caller_did }
  user: load(),

  // legacy (kept for backwards-compat path on older clients)
  login: (extension, name) => {
    const user = { extension: String(extension), name: name?.trim() || `סוכן ${extension}` }
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(user)) } catch {}
    set({ user })
  },

  // multi-tenant login — set the full server response
  loginWithToken: (sessionResponse, name) => {
    const user = {
      name: name?.trim() || 'סוכן',
      extension: String(sessionResponse.extension),
      sip_password: sessionResponse.sip_password,
      sip_domain: sessionResponse.sip_domain,
      ws_url: sessionResponse.ws_url,
      agent_token: sessionResponse.agent_token,
      expires_at: sessionResponse.expires_at,
      business: sessionResponse.business,
      dids: sessionResponse.dids || [],
      default_caller_did: sessionResponse.default_caller_did,
    }
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(user)) } catch {}
    set({ user })
  },

  logout: () => {
    try { localStorage.removeItem(STORAGE_KEY) } catch {}
    set({ user: null })
  },
}))

export default useUserStore
